import { ArrowRight, ShoppingBag, Wrench } from "lucide-react";

export const TwoLanes = ({ onBookRepair }) => (
  <section className="bg-ink text-white" data-testid="two-lanes-section">
    <div className="max-w-7xl mx-auto grid md:grid-cols-2">
      <a href="#phones" className="group p-8 md:p-12 border-b md:border-b-0 md:border-r border-white/10 hover:bg-brand-600 transition-colors" data-testid="lane-buy">
        <ShoppingBag className="h-8 w-8 text-brand-400 group-hover:text-white transition-colors" />
        <h2 className="font-display mt-5 text-2xl md:text-3xl font-bold">Buy a phone</h2>
        <p className="mt-3 text-slate-300 group-hover:text-white/90 max-w-md">New & A+ used iPhones, Samsung phones, tablets and accessories — see prices, then message us to reserve.</p>
        <span className="mt-6 inline-flex items-center gap-2 font-semibold">Browse phones <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
      </a>
      <button onClick={onBookRepair} className="group text-left p-8 md:p-12 hover:bg-brand-600 transition-colors" data-testid="lane-repair">
        <Wrench className="h-8 w-8 text-brand-400 group-hover:text-white transition-colors" />
        <h2 className="font-display mt-5 text-2xl md:text-3xl font-bold">Get it fixed</h2>
        <p className="mt-3 text-slate-300 group-hover:text-white/90 max-w-md">Screens, batteries, charging ports, tablets and laptops — tell us what's wrong and we'll give you an honest quote.</p>
        <span className="mt-6 inline-flex items-center gap-2 font-semibold">Book a repair <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
      </button>
    </div>
  </section>
);
